import React from "react";
import {useSelector} from "react-redux";
import TextInput from "../../Components/Inputs/TextInput";
import ReactMultiSelectInput from "../../Components/Inputs/ReactMultiSelectInput";
import ReactDateTimePicker from "../../Components/Inputs/ReactDateTimePicker";
import ReactSelectInput from "../../Components/Inputs/ReactSelectInput";
import {useState, useEffect} from "react";

export default function ({register, errors, control, data, watch}) {

  const user = useSelector(state => state.user);
  const isSeller = user?.roles?.includes('Seller');
  const [defaultShop, setDefaultShop] = useState(null);

  useEffect(() => {
    setDefaultShop(data?.shops?.[0]?.id)
  }, [data]);

  return (<>
    <TextInput
      label="Name"
      name="name"
      parentClasses="col-lg-6"
      register={register}
      required={true}
      errorMessage={errors?.name}
    />

    {
      (isSeller && defaultShop) && (
        <ReactSelectInput
          label="Shop"
          name="shop_id"
          inputClassName="col-lg-6"
          placeholder="Choose shop"
          defaultValue={defaultShop}
          register={register}
          options={data?.shops}
          errorMessage={errors?.shop_id}
          control={control}
        />
      )
    }

    {
      !isSeller && (
        <ReactSelectInput
          label="Shop"
          name="shop_id"
          inputClassName="col-lg-6"
          placeholder="Choose shop"
          register={register}
          options={data?.shops}
          errorMessage={errors?.shop_id}
          control={control}
        />
      )
    }

    <ReactDateTimePicker
      label="Start Date"
      name="start_date"
      placeholder="dd/mm/yyyy hh:mm"
      dateFormat="dd/MM/yyyy HH:mm"
      showTimeSelect={true}
      parentClasses="col-lg-6 mb-lg-0 mb-12"
      register={register}
      errorMessage={errors?.start_date}
      control={control}
    />
    <ReactDateTimePicker
      label="End Date"
      name="end_date"
      placeholder="dd/mm/yyyy hh:mm"
      dateFormat="dd/MM/yyyy HH:mm"
      showTimeSelect={true}
      parentClasses="col-lg-6 mb-lg-0 mb-5"
      register={register}
      errorMessage={errors?.end_date}
      control={control}
    />
    <ReactMultiSelectInput
      label="Products"
      name="products"
      placeholder="Choose Products"
      parentClasses="mt-8"
      inputClassName="col-lg-6"
      register={register}
      values={data?.products}
      errorMessage={errors?.products}
      control={control}
      required={true}
    />
  </>);
}